import axios from 'axios';
import React, { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router';
import { BsPlusCircleFill } from "react-icons/bs";
import { CiEdit } from "react-icons/ci";
import { RiDeleteBin5Line, RiGalleryUploadLine } from "react-icons/ri";


import Select from 'react-select';

const customStyles = {
  control: (base: any, state: any) => ({
    ...base,
    border: 'none',
    boxShadow: 'none',
    '&:hover': {
      border: 'none',
    },
  }),
  valueContainer: (base: any) => ({
    ...base,
    padding: '0 6px',
  }),
  multiValue: (base: any) => ({
    ...base,
    backgroundColor: '#e0f2ff',
    borderRadius: '4px',
  }),
};
interface NewsStructure {
  id:string;
  title:string;
  img:string;
  desc:string;
  date:string;
}
interface pointstruc{
  id:number;
  type:string;
  data:number
}

const News = () => {
  const api = process.env.REACT_APP_API_URL as string;
  const[pointdata, setPointdata] = useState<pointstruc[]>([]);
  const[attendancePoint, setAttendancePoint] = useState(Number);
  useEffect (()=>{
    const fetch = async ()=>{
        try{

            const response = await axios.get(`${api}/auth/point`);
            setPointdata(response.data.data);

        }
        catch(error){
   
            //console.log('error fetching point', error);
        }
    }
    fetch();
})
useEffect(() => {
  const attendanceData = pointdata.filter((items) => items.type === 'Attendance');
  if (attendanceData.length > 0) {
    const newAttendancePoint = attendanceData[0].data;
    if (attendancePoint !== newAttendancePoint) {
      setAttendancePoint(newAttendancePoint as any);
    }
  }
}, [pointdata, attendancePoint]);  // Only trigger effect when pointdata or attendancePoint changes


// console.log('attendance point data here.. ',attendancePoint);
    const [searchNotFound, setSearchNotFound] = useState<string>('');
  const [selectedPostId, setSelectedPostId] = useState<string | null>(null);
  const [newData, setNewData] = useState<NewsStructure[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const[NewPopup,setNewsPopup] = useState(false);

  const [usersData, setUsersData] = useState([]);

  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = async () => {
    
    //console.log('Searching for:', searchQuery);
  
    try {
      // Make sure the searchQuery is not empty before making the request
      if (!searchQuery) {
        alert('Please enter a search term');
        return;
      }
  
      // Sending a GET request to the backend with the search query
      const response = await axios.get(`${api}/auth/news/search/${searchQuery}`);
      //console.log('news data',response.data)
      setNewData(response.data);
      
      // Log the response data for debugging
      //console.log('Search results:', response.data);
      setSearchNotFound('');
      // Handle the data (e.g., updating state, displaying results)
      // For example, you could update the state here
      // setSearchResults(response.data);
  
    } catch (error) {
      setSearchNotFound('Not Found')
      console.error('Error during search:', error);
    }
  };
  

  // Open modal
  const openModal = (postId: string) => {
    setSelectedPostId(postId);
    setIsModalOpen(true);
  };

  // Function to close modal and clear the post ID
  const closeModal = () => {
    setSelectedPostId(null);
    setIsModalOpen(false);
  };

  const closeNewspop =()=>{
    setNewsPopup(false);
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<NewsStructure[]>(
          `${api}/auth/news`
        );

        //console.log('news data',response.data)
        setNewData(response.data);
        //console.log("news data in a array",newData);
      } catch (error) {
        console.error("Post Not Found:", error);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${api}/auth/inserdata`
        );

        //console.log('media data inserted',response.data)
        setNewData(response.data);
        //console.log("media data in a array",newData);
      } catch (error) {
        console.error("media data Not Found:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchAllUserData = async () => {
      try {
        const response = await axios.get(
          `${api}/auth/allusersinfo`
        );
  
        //console.log("All users data:", response.data);
        setUsersData(response.data); // Set users data
      } catch (error) {
        console.error("Failed to fetch users:", error);
      }
    };
  
    fetchAllUserData();
  }, []);

  function deletePost(id: string): void {
    const confirmation = window.confirm('Are you sure you want to delete this post?');
    
    if (confirmation) {
      axios
        .delete(`${api}/auth/news/${id}`)
        .then((response) => {
          // Handle the success case
          alert('Post deleted successfully');
          //console.log(response.data); // Log the response or update your state/UI
          window.location.reload();
        })
        .catch((error) => {
          // Handle errors
          console.error('Error deleting post:', error);
          alert('Failed to delete the post. Please try again.');
        });
    }
  }

  
 
  return (
    <div>
         {/* news header  */}
         <div
  className="flex flex-wrap justify-between items-center sticky top-0 z-10 px-4 sm:px-8 md:px-12 w-full left-0 right-0 lg:h-[74px] h-[150px] "
  style={{
    WebkitBackdropFilter: 'blur(22px)',
    backdropFilter: 'blur(22px)',
  }}
>
  {/* Add Event Button */}
  <div
    className="flex items-center cursor-pointer h-[40px] md:h-[45px] px-2 py-1 md:py-2 bg-[#FDBC12] text-darkblue rounded-lg gap-2 mb-2 sm:mb-0"
    onClick={() => openModal('')}
  >
    <BsPlusCircleFill /> <h6 className="text-sm md:text-base">Add Event</h6>
  </div>

  {/* Add Text News Button */}
  <div
    className="flex items-center cursor-pointer h-[40px] md:h-[45px] px-2 py-1 md:py-2 bg-[#FDBC12] text-darkblue rounded-lg gap-2 mb-2 sm:mb-0"
    onClick={() => setNewsPopup(true)}
  >
    <BsPlusCircleFill /> <h6 className="text-sm md:text-base">Add Text News</h6>
  </div>

  {/* Search Input */}
  <div className="w-full sm:w-auto flex flex-col sm:flex-row items-center gap-2 sm:gap-4">
    <div className="bg-transparent border h-[40px] md:h-[45px] border-darkblue px-2 rounded-lg flex items-center w-full sm:w-auto">
      <input
        type="search"
        name="search"
        className="placeholder-darkblue border-none outline-none bg-transparent flex-grow text-sm md:text-base"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        placeholder="Write here..."
      />
      <button
        className="cursor-pointer px-2 border-l border-darkblue h-full flex items-center justify-center text-sm md:text-base"
        onClick={handleSearch}
      >
        Search
      </button>
    </div>
    {searchNotFound && (
      <p className="text-red-500 text-sm md:text-base mt-1 sm:mt-0">{searchNotFound}</p>
    )}
  </div>
</div>


         <div>
         {NewPopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg w-[50%] h-auto">
            {/* Close button */}
            {/* <button onClick={closeModal} className="text-red-500 font-bold absolute top-4 right-4">
              X
            </button> */}
            <ModalNews  onCloseNewsPop={closeNewspop} />
          </div>
        </div>
      )}

         {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg w-[50%] h-auto">
            {/* Close button */}
            {/* <button onClick={closeModal} className="text-red-500 font-bold absolute top-4 right-4">
              X
            </button> */}
            <Modal users={usersData} postId={selectedPostId} onClose={closeModal}  attendancePoint={attendancePoint}/>
          </div>
        </div>
      )}
{newData.length > 0 ? (
     <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 lg:p-12 p-3">
          {newData.map((item) => (
            <div className='bg-white rounded-lg p-2 drop-shadow-md'>
              <img
      className="h-[250px] object-contain w-full max-w-full rounded-lg"
      src={
        item.img
          ? item.img.startsWith("http")
            ? item.img // Use the full URL if already valid
            : `${api}/${item.img}` // Prepend base URL for relative paths
          : "https://via.placeholder.com/150" // Placeholder image for missing URLs
      }
      alt={item.title || "Image"}
    />
               
               <h3 className='font-semibold text-lg py-4 '>{item.title}</h3>
               <div className='flex justify-between gap-4'> 
                
                <div className='flex w-[130px] justify-center cursor-pointer   py-2 border border-darkblue  text-darkblue items-center rounded-lg gap-2' onClick={() => openModal(item.id)}>
             <CiEdit/>  <h6>Edit Event</h6>
            </div>
            
                <div className='flex  w-[130px] justify-center cursor-pointer   py-2 border border-red-600 text-red-600 items-center rounded-lg gap-2' onClick={() => deletePost(item.id)}>
             <RiDeleteBin5Line/>  <h6>Delete Event</h6>
            </div>

            </div>
               
            </div>
          ))}
       </div>
      ) : (
        <p>Loading...</p>
      )}
         </div>
          
        
    </div>
  )
}

type AttendeeStatus = {
  present: boolean;
  leave: boolean;
  substitute: boolean;
  late: boolean;
};

type Attendee = {
  id: number;
  name: string;
  status: 'present' | 'leave' | 'substitute' | 'late' | 'absent' | 'N/R' | null; // Only one status at a time
};

type AttendeeStatusKey = keyof AttendeeStatus;
interface ModalProps {
  postId?: string | null; 
  onClose: () => void;
  users: { id: number; name: string;}[]; 
  attendancePoint :number | null;
}

const Modal: React.FC<ModalProps> = ({ users, postId, onClose,attendancePoint }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [attendees, setAttendees] = useState<Attendee[]>([]);
  const[oldattendees,setOldAttendees] = useState<Attendee[]>([]);
  const[pointdata, setPointdata] = useState<pointstruc[]>([]);
  useEffect (()=>{
    const fetch = async ()=>{
        try{

            const response = await axios.get(`${api}/auth/point`);
            setPointdata(response.data.data);

        }
        catch(error){
   
            //console.log('error fetching point', error);
        }
    }
    fetch();
})

  const [fileList, setFileList] = useState<File[]>([]);
  const api = process.env.REACT_APP_API_URL as string;


  const formatDate = (isoDate: string): string => {
    const date = new Date(isoDate);
  
    // Ensure it's in Asia/Kolkata timezone and formatted correctly
    return new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Asia/Kolkata', // Adjust for the correct timezone
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    })
      .format(date)
      .split("/")
      .reverse()
      .join("-"); // Convert "DD/MM/YYYY" -> "YYYY-MM-DD"
  };
  
  
  
  
  const [formData, setFormData] = useState({
    title: '',
    content: '',
    date: '',
    otherrmbians: [] as number[],
    image: null as File | null,
    RMBiansOfMeeting: null as number | null,
    // attendees: [] as number[], // Store selected attendees (user IDs)
    attendees: [] as { id: number; status: "present" | "leave" | "substitute" | "late" | "absent" | "N/R" |null }[], 
    Gallery:'',
    Presentation_First:null as number | null,	
    Presentation_Second:null as number | null



  });
  const [fileName, setFileName] = useState<string | null>(null);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    if (postId) {
      const fetchPost = async () => {
        try {
          const response = await axios.get(`${api}/auth/news/${postId}`);
  

          const data = Array.isArray(response.data) ? response.data[0] : response.data;
 // Access the first element
  
          // Destructure from the first element of the array
          const { title, content, date, img: image,RMBiansOfMeeting, PresentMember: attendees, Gallery,Presentation_First,Presentation_Second,	OtherRMBians } = data;
 

           const otherrmbiansarray =OtherRMBians?  OtherRMBians.split('&').map(Number): [];
            
            const formattedGalleryImages = Gallery.split('&').map((imagePath: string) => ({
              src: `/${imagePath}`, // Adjust this path based on your server's setup
              alt: imagePath.split('/').pop(), // Get the file name as the alt text (optional)
            }));
          
            // Fetch images and create File objects
            const fetchFiles = async () => {
              const files: File[] = await Promise.all(
                formattedGalleryImages.map(async (image:any) => {
                  const response = await fetch(image.src); // Fetch the image
                  const blob = await response.blob(); // Convert response to Blob
                  const fileName = image.src.split('/').pop() || 'file'; // Extract file name
                  return new File([blob], fileName, { type: blob.type }); // Create File object
                })
              );
          
              setFileList(files);
            };
          
            fetchFiles();
          

            const attendeesArray2 = attendees
            ? JSON.parse(attendees).map((item: any) => {
                // Find the user data corresponding to the attendee's ID
                const user = users.find((user: any) => user.id === item.id);
                // Return the attendee object with id, status, and name
                return {
                  id: item.id,
                  status: item.status,
                  name: user ? user.name : '', // Add name if found, otherwise default to an empty string
                };
              })
            : [];
            
            const attendeesArray = users.map((user) => {
              // Check if the user exists in attendees
              const attendee = attendees
                ? JSON.parse(attendees).find((item: any) => item.id === user.id)
                : null;
            
              // Return the user object with updated data if found in attendees
              return {
                id: user.id,
                name: user.name,
                status: attendee ? attendee.status : null, // Add status if found, default to null
              };
            });
            
            console.log(attendeesArray);
            
          
          if (attendeesArray.length > 0) {
            setAttendees(attendeesArray);
          setOldAttendees(attendeesArray);
          }
          //console.log('attendeesArray: ', attendeesArray);
  
  //console.log("Title:", title);
  //console.log("Content:", content);
  //console.log("Date:", date);
  //console.log("Image:", image);
  setFormData({
    title,
    content,
    date: formatDate(date), // Convert the date
    image: image || null,
    RMBiansOfMeeting, 
    attendees: attendeesArray,
    Gallery,
    Presentation_First,
    Presentation_Second,
    otherrmbians:otherrmbiansarray,	
  
  });
  
          setFileName(image);
        } catch (err) {
          console.error('Error fetching post:', err);
        }
      };
      fetchPost();
    }
  }, [postId]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleAttendeesChange = (selectedOptions: any) => {
    // Extract selected user IDs from the react-select
    const selectedIds = selectedOptions ? selectedOptions.map((option: any) => option.value) : [];

    setFormData((prev) => ({ ...prev, attendees: selectedIds }));

  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  
    
    const file = e.target.files?.[0] || null;
    setFormData((prev) => ({ ...prev, image: file }));
    setFileName(file ? file.name : null);

    
     // handling multiple file
     
  };

  
  const handlegalleryChange = (e: React.ChangeEvent<HTMLInputElement>) => {

     // handling multiple file
     const files = e.target.files;
     //console.log("file from here...", files?.length)
    if (files) {
      setFileList(Array.from(files)); // Convert FileList to Array and set state
      
    }
    //console.log(fileList);
  };


  useEffect(() => {
    const attendeesWithStatus = users.map((user) => ({
      id: user.id,
      name:user.name,        
      status: null,     
    }));
    setAttendees(attendeesWithStatus);
  }, []);
  // Handle checkbox change (update status)
  const handleCheckboxChange2 = (userId: number, selectedStatus: Attendee['status']) => {
    setAttendees((prevAttendees) =>
      prevAttendees.map((attendee) =>
        attendee.id === userId
          ? {
              ...attendee,
              status: attendee.status === selectedStatus ? null : selectedStatus, // Toggle the status
            }
          : attendee
      )
    );
    setFormData((prevFormData) => ({
      ...prevFormData,
      attendees: prevFormData.attendees.map((attendee) =>
        attendee.id === userId
          ? {
              ...attendee,
              status: attendee.status === selectedStatus ? null : selectedStatus, // Toggle status
            }
          : attendee
      ),
    }));
  };
  const handleCheckboxChange = (userId: number, selectedStatus: "present" | "leave" | "substitute" | "late" | "absent" | "N/R") => {
    const updatedAttendees = attendees.map((attendee) =>
      attendee.id === userId
        ? {
            ...attendee,
            status: attendee.status === selectedStatus ? null : selectedStatus, // Toggle status
          }
        : attendee
    );
    setAttendees(updatedAttendees); // Update the attendees state

    setFormData((prevFormData) => ({
      ...prevFormData,
      attendees: updatedAttendees.map((attendee) => ({
        id: attendee.id,
        status: attendee.status, // Only keep id and status
      })),
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
  
    // Validate fields
    if (!formData.title || !formData.content || !formData.date || !formData.RMBiansOfMeeting  || !formData.Presentation_First || !formData.Presentation_Second  || !formData.image) {
      setError('All fields are required.');
      return;
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      attendees,
    }));
    
    //console.log("filelist at submit ",fileList);

  
  
    const data = new FormData();
    data.append('title', formData.title);
    data.append('content', formData.content);
    data.append('date', formData.date);
    if (formData.image) {data.append('image', formData.image);}
    
    else if(fileName){
     
      data.append('image',fileName);
    }
    data.append('RMBiansOfMeeting', String(formData.RMBiansOfMeeting));
    data.append('Presentation_First', String(formData.Presentation_First));
    data.append('Presentation_Second', String(formData.Presentation_Second));

  
  
    fileList.forEach((file) => {
      data.append("images", file); // Append each file to the FormData object
    });

     console.log('data to be submit of attendees is:', formData.attendees);
     console.log('attendees is:', attendees);
     
     data.append('attendees', JSON.stringify(formData.attendees));

     data.append('otherRmbians', formData.otherrmbians.join('&'));
     
     const pointdatatoapi = new FormData();
     pointdatatoapi.append('attendees', JSON.stringify(formData.attendees));
     pointdatatoapi.append('olddata', JSON.stringify(oldattendees));
     pointdatatoapi.append('attendancePoint', String(attendancePoint));
     pointdatatoapi.append('pointstruct', JSON.stringify(pointdata));

     
     try{
      await axios.put(`${api}/auth/addattendancepoint`, pointdatatoapi, {
        headers: { 'Content-Type': 'application/json' },
      });
     }
     catch(err) {
      console.error('Error submitting attendance point to users:', err);
     }


    try {
      if (postId) {
        await axios.put(`${api}/auth/news/${postId}`, data, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        //console.log('Post updated successfully');
      } else {
        await axios.post(`${api}/auth/news`, data, {
          headers: { },
        });
        //console.log('Post created successfully');
      }
      onClose();
      window.location.reload();
    } catch (err) {
      console.error('Error submitting post:', err);
      setError('Failed to submit the post. Please try again.');
    }
  };
  
const rmbianOptions = useMemo(() => 
  users.filter((user)=>user.id!==formData.RMBiansOfMeeting).map(user => ({ value: user.id, label: user.name })),
[users, formData.RMBiansOfMeeting]);

const selectedRmbians = useMemo(() =>
  rmbianOptions.filter(option => formData.otherrmbians.includes(option.value)),
[formData.otherrmbians, rmbianOptions]);
 
  const handleSave = () => {
    // console.log('Saved attendees:', attendees);
    setIsModalOpen(false); // Close the modal
  };

  const handleCancel = () => {
    setIsModalOpen(false); // Close the modal without saving
  };


  return (
    <>
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 hidden">
      <div className="bg-white lg:w-1/2 md:w-[75%]  w-[96%] p-6 rounded shadow relative h-[670px] overflow-y-auto">
        
        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Title */}
          <div>
            <label className="text-[#030303] font-medium"> Post title</label>
            <div className=" mt-1 w-[100%]  h-[50px]  border px-2 border-[#94A2B8] rounded-lg flex justify-center items-center mb-4 ">
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
             placeholder="Write your post title here..."
                            className="w-full bg-transparent placeholder-[#94A2B8] outline-none text-[14px]"
              required
            />
            </div>
          </div>

          {/* Attendees (Multi-Select Dropdown with checkboxes) */}
          {/* <div>
            <label className="text-[#030303] font-medium">Select Attendees</label>
            <Select
              isMulti
              name="attendees"
              options={users.map((user) => ({
                value: user.id,
                label: user.name,
              }))}
              value={formData.attendees.map((id) => ({
                value: id,
                label: users.find((user) => user.id === id)?.name || '', // Find name by ID
              }))}
              onChange={handleAttendeesChange}
              className="mt-1"
            />
          </div> */}

          {/*popup attendance */}
          <div>
      {/* Trigger Button */}
      <button
       type="button" 
        onClick={() => setIsModalOpen(true)}
        className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
      >
        Mark Attendance
      </button>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center">
          <div className="bg-white rounded-lg shadow-lg w-3/4 max-w-2xl">
            <div className="p-4 border-b">
              <h3 className="text-lg font-semibold text-gray-700">Mark Attendance</h3>
            </div>
            <div className="p-4 max-h-96 overflow-y-auto">
            {attendees.filter((user)=>user.name!=='rajnish' && user.name !=='admin').map((user) => (
        <div key={user.id} className="p-4 border mb-4">
          <h3 className="font-medium">{user.name}</h3>
          <div className="flex space-x-4">
            {['present', 'leave', 'substitute', 'late', 'absent', 'N/R'].map((status) => (
              <label key={status} className="flex items-center space-x-2">
                <input
                  type="radio"
                  name={`status-${user.id}`} // Ensure only one status is selected per user
                  className="form-radio text-blue-600"
                  onChange={() => handleCheckboxChange(user.id, status as "present" | "leave" | "substitute" | "late" | "absent" |"N/R")}
                  checked={user.status === status} // Check if the status matches
                />
                <span>{status.charAt(0).toUpperCase() + status.slice(1)}</span>
              </label>
            ))}
          </div>
        </div>
      ))}
            </div>
            <div className="p-4 border-t flex justify-end space-x-2">
              <button
                onClick={handleCancel}
                className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                onClick={handleSave}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>

           {/* RMBiansOfMeeting */}
           <div>
            <label className="text-[#030303] font-medium"> RMBians Of Meeting</label>
            <div className=" mt-1 w-[100%]  h-[50px]  border px-2 border-[#94A2B8] rounded-lg flex justify-center items-center mb-4 ">
            <select
  name="RMBiansOfMeeting"
  id=""
  value={formData.RMBiansOfMeeting ?? ''} // Use '' if no value is selected
  className="w-[100%] border-none outline-none"
  onChange={(e) =>
    setFormData({
      ...formData,
      RMBiansOfMeeting: e.target.value === '' ? null : Number(e.target.value), // Parse value as number or set to null
    })
  }
>
  <option value="" disabled>
    Select RMBians Of Meeting
  </option>
  {users.map((user) => (
    <option key={user.id} value={user.id}>
      {user.name}
    </option>
  ))}
</select>


            </div>
          </div>
          
           {/*Other  RMBiansOfMeeting */}
          <div>
  <label className="text-[#030303] font-medium">Other RMBians Of Meeting</label>
  <div className="mt-1 w-full min-h-[50px] border p-0 border-[#94A2B8] rounded-lg flex justify-center items-center mb-4">
   <Select
  isMulti
  name="otherrmbians"
  options={rmbianOptions}
  value={selectedRmbians}
  className="basic-multi-select w-full border-none h-full"
  classNamePrefix="select"
  placeholder="Select Other RMBians" // 👈 This replaces the default <option>

  onChange={(selectedOptions) => {
    const selectedIds = selectedOptions.map((option) => option.value);
    setFormData({
      ...formData,
      otherrmbians: selectedIds,
    });
  }}

  styles={customStyles}
/>



  </div>
</div>


 {/* Host1 */}
 <div>
            <label className="text-[#030303] font-medium"> Host 1</label>
            <div className=" mt-1 w-[100%]  h-[50px]  border px-2 border-[#94A2B8] rounded-lg flex justify-center items-center mb-4 ">
            <select
  name="Presentation_First"
  id=""
  value={formData.Presentation_First ?? ''} // Use '' if no value is selected
  className="w-[100%] border-none outline-none"
  onChange={(e) =>
    setFormData({
      ...formData,
      Presentation_First: e.target.value === '' ? null : Number(e.target.value), // Parse value as number or set to null
    })
  }
>
  <option value="" disabled>
    Select RMBians Of Meeting
  </option>
  {users.map((user) => (
    <option key={user.id} value={user.id}>
      {user.name}
    </option>
  ))}
</select>


            </div>
          </div>



{/* Host2 */}
<div>
            <label className="text-[#030303] font-medium"> Host 2</label>
            <div className=" mt-1 w-[100%]  h-[50px]  border px-2 border-[#94A2B8] rounded-lg flex justify-center items-center mb-4 ">
            <select
  name="Presentation_Second"
  id=""
  value={formData.Presentation_Second ?? ''} // Use '' if no value is selected
  className="w-[100%] border-none outline-none"
  onChange={(e) =>
    setFormData({
      ...formData,
      Presentation_Second: e.target.value === '' ? null : Number(e.target.value), // Parse value as number or set to null
    })
  }
>
  <option value="" disabled>
    Select RMBians Of Meeting
  </option>
  {users.map((user) => (
    <option key={user.id} value={user.id}>
      {user.name}
    </option>
  ))}
</select>


            </div>
          </div>



          {/* Content */}
          <div>
            <label className="text-[#030303] font-medium">Description</label>
            <textarea
              name="content"
              value={formData.content}
              onChange={handleChange}
              className="mt-1 mb-4 p-2 block w-full h-[150px] border-[1px] border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
                        placeholder="Write your message here..."
              rows={4}
              required
            />
          </div>
          <div>
      <label className="text-[#030303] font-medium">Add Gallery</label>
      <div className="mt-1 w-[100%] h-[200px] border-dashed px-2 border-[2px] border-[#94A2B8] rounded-lg flex flex-col justify-center items-center mb-4">
        <RiGalleryUploadLine
          size={24}
          className="text-[30px] cursor-pointer"
          onClick={() => document.getElementById("gallery-image-upload")?.click()}
        />
        <input
          id="gallery-image-upload"
          type="file"
          accept="image/*"
          className="hidden"
          multiple // Allow multiple file selection
          onChange={handlegalleryChange}
        />
        {fileList.length > 0 ? (
          <ul className="text-[14px] text-[#02256d] mt-2">
            {fileList.map((file, index) => (
              <li key={index} className="font-bold">
                {file.name}
              </li>
            ))}
          </ul>
        ) : (
          <p className="font-bold text-[14px]">
            Drag and Drop or <span className="text-[#02256d]">click to upload</span>
          </p>
        )}
      </div>
    </div>
          
          {/* File Upload */}
          <div>
            <label className="text-[#030303]  font-medium">  Add thumbnail</label>
            <div className="mt-1 w-[100%] h-[200px] border-dashed px-2 border-[2px] border-[#94A2B8] rounded-lg flex flex-col justify-center items-center mb-4">
           
              <RiGalleryUploadLine size={24} className="text-[30px] cursor-pointer"
                                onClick={() => document.getElementById('file-upload')?.click()}  />
              <input
              id="file-upload"
              type="file"
              accept="image/*"
              className="hidden"
              name='image'
            
              onChange={handleFileChange}

              
            />
            {fileName ? (
  <p className="text-[14px] text-[#02256d] mt-2">
    Selected file: <span className="font-bold">{fileName}</span>
  </p>
) : (
  <p className="font-bold text-[14px]">
    Drag and Drop or{' '}
    <span className="text-[#02256d]">click to upload</span>
  </p>
)}
            </div>
            
          </div>

          {/* Error Message */}
          {error && <p className="text-red-500">{error}</p>}


<div className=' flex justify-between'>
  {/* Date */}
<div className='flex flex-col'>
            <label htmlFor="Name" className="  text-[#030303] font-medium ">Date</label>
            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
               className="mt-1 w-[150px] bg-transparent placeholder-[#94A2B8] outline-none  border  border-[#94A2B8] rounded-md p-1 text-[14px]"
              required
            />
          </div>
          <div className='flex items-center'>
            {/*Cancel form button*/}
            <button className='mt-[22px] mx-[10px] border-[#94A2B8] border px-[20px] py-[10px] rounded-md hover:bg-[#FDBC12] hover:border-none text-[14px] font-bold'  onClick={onClose}>Cancel</button>
             {/* Submit Button */}
          <button
            type="submit"
            className='mt-[22px] bg-[#FDBC12] px-[20px] py-[10px] rounded-md hover:border-[#94A2B8] hover:border hover:bg-[#fdba1200] text-[14px]  cursor-pointer font-semibold'
            disabled={!formData.title || !formData.content || !formData.date}
          >
            {postId ? 'Update Post' : 'Create Post'}
          </button>
          </div>
         

</div>


          
        </form>
      </div>
    </div>
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
  <div className="bg-white lg:w-1/2 md:w-[75%] w-[96%] p-6 rounded shadow relative h-[670px] overflow-y-auto">
    <form onSubmit={handleSubmit} className="space-y-4">
      {/* Title */}
      <div>
        <label className="text-[#030303] font-medium">Post title</label>
        <div className="mt-1 w-full h-[50px] border px-2 border-[#94A2B8] rounded-lg flex items-center mb-4">
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            placeholder="Write your post title here..."
            className="w-full bg-transparent placeholder-[#94A2B8] outline-none text-[14px]"
            required
          />
        </div>
      </div>

      {/* Attendance Modal Trigger */}
      <div>
        <button
          type="button"
          onClick={() => setIsModalOpen(true)}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          Mark Attendance
        </button>

        {/* Attendance Modal */}
        {isModalOpen && (
          <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg shadow-lg w-3/4 max-w-2xl">
              <div className="p-4 border-b">
                <h3 className="text-lg font-semibold text-gray-700">Mark Attendance</h3>
              </div>
              <div className="p-4 max-h-96 overflow-y-auto">
                {attendees
                  .filter((user) => user.name !== 'rajnish' && user.name !== 'admin')
                  .map((user) => (
                    <div key={user.id} className="p-4 border mb-4">
                      <h3 className="font-medium">{user.name}</h3>
                      <div className="flex flex-wrap gap-4 mt-2">
                        {['present', 'leave', 'substitute', 'late', 'absent', 'N/R'].map((status) => (
                          <label key={status} className="flex items-center gap-2">
                            <input
                              type="radio"
                              name={`status-${user.id}`}
                              className="form-radio text-blue-600"
                              onChange={() =>
                                handleCheckboxChange(
                                  user.id,
                                  status as 'present' | 'leave' | 'substitute' | 'late' | 'absent' | 'N/R'
                                )
                              }
                              checked={user.status === status}
                            />
                            <span>{status.charAt(0).toUpperCase() + status.slice(1)}</span>
                          </label>
                        ))}
                      </div>
                    </div>
                  ))}
              </div>
              <div className="p-4 border-t flex justify-end gap-2">
                <button
                  type="button"
                  onClick={handleCancel}
                  className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={handleSave}
                  className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* RMBians Of Meeting */}
      <div>
        <label className="text-[#030303] font-medium">RMBians Of Meeting</label>
        <div className="mt-1 w-full h-[50px] border px-2 border-[#94A2B8] rounded-lg flex items-center mb-4">
          <select
            name="RMBiansOfMeeting"
            value={formData.RMBiansOfMeeting ?? ''}
            className="w-full border-none outline-none"
            onChange={(e) =>
              setFormData({
                ...formData,
                RMBiansOfMeeting: e.target.value === '' ? null : Number(e.target.value),
              })
            }
          >
            <option value="" disabled>
              Select RMBians Of Meeting
            </option>
            {users.map((user) => (
              <option key={user.id} value={user.id}>
                {user.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Other RMBians */}
      <div>
        <label className="text-[#030303] font-medium">Other RMBians Of Meeting</label>
        <div className="mt-1 w-full min-h-[50px] border border-[#94A2B8] rounded-lg p-2 mb-4">
          <Select
            isMulti
            name="otherrmbians"
            options={rmbianOptions}
            value={selectedRmbians}
            className="w-full"
            classNamePrefix="select"
            placeholder="Select Other RMBians"
            onChange={(selectedOptions) => {
              const selectedIds = selectedOptions.map((option) => option.value);
              setFormData({
                ...formData,
                otherrmbians: selectedIds,
              });
            }}
            styles={customStyles}
          />
        </div>
      </div>

      {/* Host 1 */}
      <div>
        <label className="text-[#030303] font-medium">Host 1</label>
        <div className="mt-1 w-full h-[50px] border px-2 border-[#94A2B8] rounded-lg flex items-center mb-4">
          <select
            name="Presentation_First"
            value={formData.Presentation_First ?? ''}
            className="w-full border-none outline-none"
            onChange={(e) =>
              setFormData({
                ...formData,
                Presentation_First: e.target.value === '' ? null : Number(e.target.value),
              })
            }
          >
            <option value="" disabled>
              Select Host 1
            </option>
            {users.map((user) => (
              <option key={user.id} value={user.id}>
                {user.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Host 2 */}
      <div>
        <label className="text-[#030303] font-medium">Host 2</label>
        <div className="mt-1 w-full h-[50px] border px-2 border-[#94A2B8] rounded-lg flex items-center mb-4">
          <select
            name="Presentation_Second"
            value={formData.Presentation_Second ?? ''}
            className="w-full border-none outline-none"
            onChange={(e) =>
              setFormData({
                ...formData,
                Presentation_Second: e.target.value === '' ? null : Number(e.target.value),
              })
            }
          >
            <option value="" disabled>
              Select Host 2
            </option>
            {users.map((user) => (
              <option key={user.id} value={user.id}>
                {user.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Description */}
      <div>
        <label className="text-[#030303] font-medium">Description</label>
        <textarea
          name="content"
          value={formData.content}
          onChange={handleChange}
          className="mt-1 mb-4 p-2 block w-full h-[150px] border border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
          placeholder="Write your message here..."
          rows={4}
          required
        />
      </div>

      {/* Gallery Upload */}
      <div>
        <label className="text-[#030303] font-medium">Add Gallery</label>
        <div className="mt-1 w-full h-[200px] border-dashed border-2 border-[#94A2B8] rounded-lg flex flex-col justify-center items-center mb-4">
          <RiGalleryUploadLine
            size={30}
            className="text-[#02256d] cursor-pointer"
            onClick={() => document.getElementById('gallery-image-upload')?.click()}
          />
          <input
            id="gallery-image-upload"
            type="file"
            accept="image/*"
            multiple
            className="hidden"
            onChange={handlegalleryChange}
          />
          {fileList.length > 0 ? (
            <ul className="text-[14px] text-[#02256d] mt-2">
              {fileList.map((file, index) => (
                <li key={index} className="font-bold">
                  {file.name}
                </li>
              ))}
            </ul>
          ) : (
            <p className="font-bold text-[14px]">
              Drag and Drop or <span className="text-[#02256d]">click to upload</span>
            </p>
          )}
        </div>
      </div>

      {/* Thumbnail Upload */}
      <div>
        <label className="text-[#030303] font-medium">Add thumbnail</label>
        <div className="mt-1 w-full h-[200px] border-dashed border-2 border-[#94A2B8] rounded-lg flex flex-col justify-center items-center mb-4">
          <RiGalleryUploadLine
            size={30}
            className="text-[#02256d] cursor-pointer"
            onClick={() => document.getElementById('file-upload')?.click()}
          />
          <input
            id="file-upload"
            type="file"
            accept="image/*"
            name="image"
            className="hidden"
            onChange={handleFileChange}
          />
          {fileName ? (
            <p className="text-[14px] text-[#02256d] mt-2">
              Selected file: <span className="font-bold">{fileName}</span>
            </p>
          ) : (
            <p className="font-bold text-[14px]">
              Drag and Drop or <span className="text-[#02256d]">click to upload</span>
            </p>
          )}
        </div>
      </div>

      {/* Error Message */}
      {error && <p className="text-red-500">{error}</p>}

      {/* Date & Buttons */}
      <div className="flex justify-between items-end">
        <div className="flex flex-col">
          <label className="text-[#030303] font-medium">Date</label>
          <input
            type="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
            className="mt-1 w-[150px] bg-transparent placeholder-[#94A2B8] outline-none border border-[#94A2B8] rounded-md p-1 text-[14px]"
            required
          />
        </div>
        <div className="flex gap-3">
          <button
            type="button"
            className="border-[#94A2B8] border px-5 py-2 rounded-md hover:bg-[#FDBC12] hover:border-none text-[14px] font-bold"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="bg-[#FDBC12] px-5 py-2 rounded-md hover:border-[#94A2B8] hover:border hover:bg-transparent text-[14px] cursor-pointer font-semibold"
            disabled={!formData.title || !formData.content || !formData.date}
          >
            {postId ? 'Update Post' : 'Create Post'}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>

    </>
  );
};

interface NewsProps {
  onCloseNewsPop: () => void;
}

const ModalNews: React.FC<NewsProps> = ({ onCloseNewsPop }) => {
  const [formData, setFormData] = useState({ title: "" });
  const api = process.env.REACT_APP_API_URL as string;
  // Fetch data from API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${api}/auth/newsheading`);
        //console.log("Fetched news heading data:", response.data);
        
        if (response.data && response.data.data && response.data.data.length > 0) {

          setFormData({ title: response.data.data[0].title });
        }
      } catch (error) {
        console.error("Failed to fetch news heading:", error);
      }
    };

    fetchData();
  }, []);

  //console.log("form data title", formData.title);
  // Handle input change
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle form submission
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.title) {
      alert("Please enter a title");
      return;
    }

    try {
      //console.log("Updating news heading:", formData.title);
      await axios.put(
        `${api}/auth/newsheading`,
        { title: formData.title },
        { headers: { "Content-Type": "application/json" } }
      );

      //console.log("News heading updated successfully");
      window.location.reload(); // Reload page to reflect changes
    } catch (error) {
      console.error("Failed to update news heading:", error);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white w-full max-w-lg p-6 rounded shadow-md relative">
        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Title Input */}
          <div>
            <label htmlFor="title" className="text-gray-800 font-medium">
              Post Title
            </label>
            <div className="mt-2 w-full h-12 border px-3 border-gray-300 rounded-lg flex items-center">
              <input
                type="text"
                id="title"
                name="title"
                value={formData.title}
                onChange={handleChange}
                placeholder="Write your post title here..."
                className="w-full bg-transparent placeholder-gray-400 outline-none text-sm"
                required
              />
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex justify-end space-x-4">
            <button
              type="button"
              onClick={onCloseNewsPop}
              className="px-4 py-2 border border-gray-300 rounded-md text-sm hover:bg-gray-100"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-yellow-500 text-white rounded-md text-sm hover:bg-yellow-600"
            >
              Update News Heading
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default News